import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Container, Table } from "react-bootstrap";

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-appointments`
      );
      setAppointments(res.data.appointments);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch appointments", "error");
    }
  };

  return (
    <Container className="mt-4">
      <h3 className="text-primary mb-4">Appointments</h3>

      {/* Appointments Table */}
      <Table
        bordered
        hover
        responsive
        className="text-center"
        style={{ backgroundColor: "aliceblue" }}
      >
        <thead className="table-primary">
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Doctor Name</th>
            <th>Appointment Date</th>
            <th>Appointment Time</th>
            <th>Status</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {appointments.length > 0 ? (
            appointments.map((appointment, index) => (
              <tr key={appointment.id}>
                <td>{index + 1}</td>
                <td>{appointment.user_name}</td>
                <td>{appointment.doctor_name}</td>
                <td>
                  {new Date(appointment.appointment_date).toLocaleDateString(
                    "en-GB"
                  )}
                </td>
                <td>{appointment.appointment_time}</td>
                <td>{appointment.status}</td>
                <td>{appointment.remark}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No appointments found.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default Appointments;
